import "./DoubtRoom.css";
import { useState, useRef, useEffect } from "react";
import tutorImg from "./assets/teacher_5.png";

const topicQuestions = {
  "Python Basics": [
    "What is Python?",
    "What are variables?",
    "Explain data types",
  ],
  "Loops": [
    "What is for loop?",
    "Difference between for and while",
    "Give loop example",
  ],
  "Functions": [
    "What is a function?",
    "Why use functions?",
    "Example of function",
  ],
};

export default function DoubtRoom() {
  const [topic, setTopic] = useState("Python Basics");
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    { from: "tutor", text: "Hi 👋 I am your doubt assistant. Ask me anything!" },
  ]);

  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = (text) => {
    if (!text.trim()) return;

    setMessages((prev) => [...prev, { from: "user", text }]);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          from: "tutor",
          text: `Good question! I'll explain about "${text}" in simple way 🙂`,
        },
      ]);
    }, 600);

    setInput("");
  };

  return (
    <div className="doubt-room">

      {/* LEFT PANEL */}
      <div className="doubt-left">
        <img src={tutorImg} alt="Tutor" />
        <h3>AI Tutor</h3>
        <span className="status">🟢 Online</span>

        <div className="topics-box">
          <h4>Topics</h4>
          {Object.keys(topicQuestions).map((t) => (
            <button
              key={t}
              className={t === topic ? "active" : ""}
              onClick={() => setTopic(t)}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {/* RIGHT CHAT AREA */}
      <div className="doubt-right">

        {/* HEADER */}
        <div className="chat-header">
          📌 Current Topic: <b>{topic}</b>
        </div>

        {/* CHAT MESSAGES */}
        <div className="chat-box">
          {messages.map((m, i) => (
            <div
              key={i}
              className={`chat-msg ${m.from === "user" ? "user" : "tutor"}`}
            >
              {m.text}
            </div>
          ))}
          <div ref={chatEndRef}></div>
        </div>

        {/* QUICK QUESTIONS */}
        <div className="quick-questions">
          {topicQuestions[topic].map((q, i) => (
            <button key={i} onClick={() => sendMessage(q)}>
              {q}
            </button>
          ))}
        </div>

        {/* INPUT */}
        <div className="chat-input">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask your doubt..."
            onKeyDown={(e) => e.key === "Enter" && sendMessage(input)}
          />
          <button onClick={() => sendMessage(input)}>➤</button>
        </div>

      </div>
    </div>
  );
}
